import './index.scss'
import {useSelector} from 'react-redux'
import TextHelper from '../../../utils/text'
import classNames from 'classnames'
import {envConfig} from '../../../utils/env'

const telegramBotUsername = envConfig.telegramBotUsername
const isTelegramWebhookUrlEnabled = envConfig.isTelegramWebhookUrlEnabled

const TelegramVerificationFlow = ({text}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const renderContent = () => {
        if (telegramBotUsername && isTelegramWebhookUrlEnabled) {
            return (
                <>
                    <p>
                        {TextHelper.replaceReactPlaceholders(text.telegram_instructions_text, ':bot', <a
                            href={`https://t.me/${telegramBotUsername}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            @{telegramBotUsername}
                        </a>)}
                    </p>
                    <p className="note">{TextHelper.replaceReactPlaceholders(text.telegram_add_group_info,
                        ':bot',
                        <strong>@{telegramBotUsername}</strong>
                    )}</p>
                </>
            )
        }

        if (telegramBotUsername && !isTelegramWebhookUrlEnabled) {
            return (
                <p dangerouslySetInnerHTML={{__html: TextHelper.replaceAllChars(
                    text.telegram_no_webhook_info,
                    ':bot',
                    `<strong>@${telegramBotUsername}</strong>`
                )}} />
            )
        }

        return (
            <p dangerouslySetInnerHTML={{__html: text.telegram_self_hosted_info}} />
        )
    }

    return (
        <div className={classNames('verification-section', {
            dark: isDarkMode
        })}>
            <div className="instructions">
                <h3>{text.how_to_connect}</h3>
                {renderContent()}
            </div>
        </div>
    )
}

export default TelegramVerificationFlow